import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  // Allows infinite number of new elements to be appended with Turbo
  resetSource(event) {
    this.frameEl = event.currentTarget;
    this.frameEl.removeAttribute('src');
  }
}
